var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 30,
    viewBox: "0 0 207 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.7578,
    y: 14.7046,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7578,
    y: 22.0571,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4062,
    y: 22.0571,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0547,
    y: 22.0571,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7031,
    y: 22.0571,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.35156,
    y: 22.0571,
    width: 7.35224,
    height: 7.35224,
    fill: "#793D20"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7031,
    y: 14.7046,
    width: 7.35224,
    height: 7.35224,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.35156,
    y: 14.7046,
    width: 7.35224,
    height: 7.35224,
    fill: "#793D20"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0547,
    y: 14.7046,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4062,
    y: 14.7046,
    width: 7.35224,
    height: 7.35224,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4062,
    y: 7.35254,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4062,
    width: 7.35224,
    height: 7.35224,
    fill: "#793D20"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0547,
    y: 7.35254,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0547,
    width: 7.35224,
    height: 7.35224,
    fill: "#793D20"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7031,
    y: 7.35254,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7031,
    width: 7.35224,
    height: 7.35224,
    fill: "#793D20"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 7.35156,
    width: 7.35224,
    height: 7.35224,
    fill: "#793D20"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 7.35156,
    y: 7.35254,
    width: 7.35224,
    height: 7.35224,
    fill: "#793D20"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    y: 7.35254,
    width: 7.35224,
    height: 7.35224,
    fill: "#CA9660"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.015 24.8139V22.2208H66.7944V24.8139H59.015ZM66.7944 22.2208V17.0346H61.6081V14.4415H69.3875V22.2208H66.7944ZM56.4219 22.2208V9.25523H59.015V22.2208H56.4219ZM66.7944 11.8483V9.25523H69.3875V11.8483H66.7944ZM59.015 9.25523V6.66211H66.7944V9.25523H59.015Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8168 24.8139V22.2208H82.5962V24.8139H74.8168ZM72.2237 22.2208V14.4415H74.8168V22.2208H72.2237ZM82.5962 22.2208V14.4415H85.1893V22.2208H82.5962ZM74.8168 14.4415V11.8483H82.5962V14.4415H74.8168Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.398 24.8139V22.2208H100.991V24.8139H98.398ZM95.8049 22.2208V19.6277H98.398V22.2208H95.8049ZM95.8049 17.0346V14.4415H98.398V17.0346H95.8049ZM98.398 14.4415V11.8483H100.991V14.4415H98.398ZM88.0255 24.8139V6.66211H90.6186V17.0346H95.8049V19.6277H90.6186V24.8139H88.0255Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.827 22.2208V11.8483H106.42V22.2208H103.827ZM106.42 24.8139V22.2208H114.2V11.8483H116.793V24.8139H106.42Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.938 24.8139V9.25523H143.531V24.8139H140.938ZM130.566 24.8139V6.66211H140.938V9.25523H138.345V24.8139H135.752V9.25523H133.159V24.8139H130.566Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.96 24.8139V22.2208H156.74V24.8139H148.96ZM146.367 22.2208V14.4415H148.96V22.2208H146.367ZM156.74 22.2208V14.4415H159.333V22.2208H156.74ZM148.96 14.4415V11.8483H156.74V14.4415H148.96Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.542 24.8139V14.4415H175.135V24.8139H172.542ZM162.169 24.8139V11.8483H172.542V14.4415H164.762V24.8139H162.169Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.564 24.8139V22.2208H188.343V24.8139H180.564ZM177.971 22.2208V14.4415H180.564V17.0346H188.343V14.4415H190.937V19.6277H180.564V22.2208H177.971ZM180.564 14.4415V11.8483H188.343V14.4415H180.564Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.366 30.0002V27.4071H204.145V30.0002H196.366ZM193.773 22.2208V11.8483H196.366V22.2208H193.773ZM204.145 27.4071V24.8139H196.366V22.2208H204.145V11.8483H206.738V27.4071H204.145Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b974d90b98adfa8e7abfd1655c64f7e2.svg";
export { ForwardRef as ReactComponent };